/* eslint-disable dot-notation */
/* eslint-disable @typescript-eslint/no-shadow */
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'contexts/Localization'
import { languageList } from 'config/localization/languages'
import useGetLocation from 'hooks/useGetLocation'
import { Select } from 'antd'
import { Us, Vn } from 'react-flags-select'

const languageOptions = [
  {
    label: (
      <div className="flex items-center gap-2 text-neutral-black dark:text-neutral-white">
        <Us /> English
      </div>
    ),
    value: 'en',
  },
  {
    label: (
      <div className="flex items-center gap-2 text-neutral-black dark:text-neutral-white">
        <Vn /> Tiếng Việt
      </div>
    ),
    value: 'vi',
  },
]

const LocalizeSelector = ({ ...props }) => {
  // localize state
  const [flag, setFlag] = useState(languageOptions?.[0]?.value)
  const { setLanguage } = useTranslation()
  const checkLocation = useGetLocation()

  useMemo(() => {
    const cacheLocalize = localStorage.getItem('localize')
    let _lang = languageOptions?.[0]?.value
    if (cacheLocalize) {
      try {
        const jsonLocalize = JSON.parse(cacheLocalize)
        _lang = jsonLocalize ? jsonLocalize?.value : languageOptions?.[0]?.value
      } catch {
        // do nothing
      }
    }

    setFlag(_lang)
  }, [])

  // update google translate selector
  const onChangeLocalize = (value) => {
    const localize = languageOptions?.find((item) => item?.value === value)
    const localizeSec = document.getElementById('google_translate_element')
    if (localizeSec) {
      const localizeSelector = localizeSec.getElementsByTagName('select')[0]
      if (localizeSelector) {
        localStorage.setItem('localize', JSON.stringify(localize))
        localizeSelector['value'] = localize.value
        const event = new Event('change')
        localizeSelector.dispatchEvent(event)
        // dispatch only time not work (is researching)
        localizeSelector.dispatchEvent(event)
      }
    }
  }

  const handleChangeLang = useCallback(
    (flag) => {
      const selectedLang = languageList.find((item) => item.locale.toLowerCase().includes(flag.toLowerCase()))
      setLanguage(selectedLang)
    },
    [setLanguage],
  )

  const handleSelect = useCallback(
    (flag) => {
      setFlag(flag)
      onChangeLocalize(flag)
      handleChangeLang(flag)
    },
    [handleChangeLang],
  )

  useEffect(() => {
    const cacheLocalize = localStorage.getItem('localize')

    if (cacheLocalize) {
      try {
        handleSelect(JSON.parse(cacheLocalize)?.value)
        return
      } catch {
        handleSelect('en')
        return
      }
    }

    handleSelect('en')
  }, [checkLocation?.country_code, handleSelect])

  return <Select onSelect={handleSelect} value={flag} className="w-full lg:w-44" options={languageOptions} {...props} />
}

export default LocalizeSelector
